import { Col, Row, message, Spin, Card } from "antd";
import "./Dasboard.css";
import TotalIcon from "../../assets/Icon1.svg";
import LiveIcon from "../../assets/Icon2.svg";
import InprogressIcon from "../../assets/Icon3.svg";
import ClosedIcon from "../../assets/Icon4.svg";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../header/Header";
import GreetingBanner from "./GreetingBanner";
import { useEffect, useState } from "react";
import { getRequestCount, getAllRequest } from "../../services/ApiService";
import { decryptObject } from "../GlobalFunction";

const parseAmount = (value) => {
  const n = parseFloat(String(value ?? "").replace(/,/g, ""));
  return Number.isNaN(n) ? 0 : n;
};

const formatAmount = (n) =>
  n.toLocaleString(undefined, { maximumFractionDigits: 2 });

// Groups Live employees' remuneration by salary currency + salary type.
// Different currencies / pay periods are never added together.
const buildPayrollRows = (records) => {
  const groups = {};
  records
    .filter((r) => r.Employee_Status === "Live" && r.Salary_Currency)
    .forEach((r) => {
      const key = `${r.Salary_Currency}|${r.Salary_Type || "-"}`;
      if (!groups[key]) {
        groups[key] = {
          key,
          currency: r.Salary_Currency,
          salaryType: r.Salary_Type || "-",
          headcount: 0,
          total: 0,
        };
      }
      groups[key].headcount += 1;
      groups[key].total += parseAmount(r.Remuneration);
    });
  return Object.values(groups).sort(
    (a, b) => a.currency.localeCompare(b.currency) || a.salaryType.localeCompare(b.salaryType)
  );
};

const PayrollByCurrency = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return <div className="activity-feed-empty">No live employees with payroll data.</div>;
  }
  return (
    <div className="payroll-grid">
      {rows.map((row) => (
        <div className="payroll-tile fade-in-up" key={row.key}>
          <span className="payroll-currency">
            {row.currency} <span className="payroll-type">· {row.salaryType}</span>
          </span>
          <span className="payroll-total">{formatAmount(row.total)}</span>
          <span className="payroll-headcount">
            {row.headcount} {row.headcount === 1 ? "employee" : "employees"}
          </span>
        </div>
      ))}
    </div>
  );
};

const FinanceDashboard = () => {
  const sessionData = decryptObject(sessionStorage.getItem("sessioninfo"));
  const name = sessionData.username;
  const [stats, setStats] = useState({});
  const [payrollRows, setPayrollRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const RequestCount = async () => {
    setLoading(true);
    try {
      const res = await getRequestCount();
      if (res.responseCode === 200) {
        setStats(res.data);
      } else {
        message.error(res.responseMessage);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };


  const fetchPayroll = async () => {
    try {
      const res = await getAllRequest(1, 1000, null, {});
      setPayrollRows(buildPayrollRows(res?.onboard_forms || []));
    } catch (error) {
      console.error("Error fetching payroll data:", error);
    }
  };

  useEffect(() => {
    // if (!hasFetchedQuote.current) {
    RequestCount();
    fetchPayroll();
    //   hasFetchedQuote.current = true;
    // }
  }, []);

  return (
    <>
      <div className="main-box">
        <Sidebar activeId={1} />
        <main className="main-content">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh",
              flex: 1,
              overflow: "hidden",
            }}
          >
            <Header title="Home" />
            <Spin
              spinning={loading}
              tip="Loading..."
              size="large"
              // style={{ minHeight: "80vh" }}
            >
              <div className="responsiveContainer" style={{ padding: 16 }}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={24}>
                    <GreetingBanner name={name} />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  {[
                    { label: "Total", icon: TotalIcon, value: stats?.totalRequest },
                    { label: "Live", icon: LiveIcon, value: stats?.live ?? stats?.onboarded },
                    { label: "Onboarding", icon: InprogressIcon, value: stats?.onboarding ?? stats?.joining },
                    { label: "Exit", icon: ClosedIcon, value: stats?.exit },
                  ].map((card, idx) => (
                    <Col xs={12} sm={12} md={6} lg={6} key={card.label}>
                      <Card
                        className="stat-card fade-in-up"
                        style={{ animationDelay: `${idx * 80}ms`, cursor: "default" }}
                        title={
                          <span style={{ display: "flex", alignItems: "center", gap: "1.4rem" }}>
                            <img src={card.icon} alt={`${card.label} Icon`} style={{ width: 35, height: 35 }} />
                            {card.label}
                          </span>
                        }
                        bordered
                      >
                        <div style={{ textAlign: "center", fontSize: "1.5rem", fontWeight: "500" }}>
                          {card.value || 0}
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={24}>
                    <Card
                      className="fade-in-up"
                      style={{ animationDelay: "320ms" }}
                      title="Live payroll by currency"
                      bordered
                    >
                      <PayrollByCurrency rows={payrollRows} />
                    </Card>
                  </Col>
                </Row>
              </div>
            </Spin>
          </div>
        </main>
      </div>
    </>
  );
};

export default FinanceDashboard;
